// -------------------------------------------------------------------------
// This file is auto-generated from UnitStrategy.tt and Units.xml.
// Do not edit directly as your changes will be lost when next regenerated.
// <auto-generated />
// -------------------------------------------------------------------------

/*! StartNoStringValidationRegion (Auto-generated file) */
import UnitStrategy from "UnitStrategy.base";

interface Strategies {
  /* eslint-disable @typescript-eslint/naming-convention -- Type property names should be camelCase */
  Area: UnitStrategy;
  Dimension: UnitStrategy;
  Distance: UnitStrategy;
  Length: UnitStrategy;
  Volume: UnitStrategy;
  Weight: UnitStrategy;
  Temperature: UnitStrategy;
  Ventilation: UnitStrategy;
  Default: UnitStrategy;
  get(unitType: string): UnitStrategy;
  getByUnit(unit: string): UnitStrategy;
  /* eslint-enable @typescript-eslint/naming-convention */
}

const strategies: Strategies = {
  get(unitType: string): UnitStrategy {
    switch (unitType) {
      case "Area":
        return strategies.Area;
      case "Dimension":
        return strategies.Dimension;
      case "Distance":
        return strategies.Distance;
      case "Length":
        return strategies.Length;
      case "Volume":
        return strategies.Volume;
      case "Weight":
        return strategies.Weight;
      case "Temperature":
        return strategies.Temperature;
      case "Ventilation":
        return strategies.Ventilation;
      case "Default":
        return strategies.Default;
      default:
        return strategies.Default;
    }
  },
  getByUnit(unit: string): UnitStrategy {
    // This is temp work around to ensure backward compatibility with Length units
    // Distance and Dimension have some of the same units that Length has so we cannot determine strategy based solely on the unit
    // Length will eventually be migrated by Distance and Dimension in WI00602211
    if (strategies.Length.hasUnit(unit)) {
      return strategies.Length;
    }
    return (
      Object.values(strategies).find((strategy) => {
        return strategy.hasUnit && strategy.hasUnit(unit);
      }) || strategies.Default
    );
  },

  Area: new UnitStrategy({
    unitType: "Area",
    defaultUnit: "M2",
    unitMaxLength: 3,
    allowNegatives: false,
    hasOffsets: false,
    items: {
      MM2: { description: "Square Millimeters", sequence: 0, factor: 0.000001 },
      CM2: { description: "Square Centimeters", sequence: 1, factor: 0.0001 },
      M2: { description: "Square Meters", sequence: 2, factor: 1 },
      HA: { description: "Hectare", sequence: 3, factor: 10000 },
      KM2: { description: "Square Kilometers", sequence: 4, factor: 1000000 },
      IN2: { description: "Square Inches", sequence: 5, factor: 0.00064516 },
      FT2: { description: "Square Feet", sequence: 6, factor: 0.09290304 },
      YD2: { description: "Square Yards", sequence: 7, factor: 0.83612736 },
      AR: { description: "Acre", sequence: 8, factor: 4046.85642 },
      MI2: { description: "Square Miles", sequence: 9, factor: 2589988.110336 },
    },
  }),

  Dimension: new UnitStrategy({
    unitType: "Dimension",
    defaultUnit: "M",
    unitMaxLength: 2,
    allowNegatives: false,
    hasOffsets: false,
    items: {
      MM: { description: "Millimeters", sequence: 0, factor: 0.001 },
      CM: { description: "Centimeters", sequence: 1, factor: 0.01 },
      M: { description: "Meters", sequence: 2, factor: 1 },
      IN: { description: "Inches", sequence: 3, factor: 0.0254 },
      FT: { description: "Feet", sequence: 4, factor: 0.3048 },
      YD: { description: "Yards", sequence: 5, factor: 0.9144 },
    },
  }),

  Distance: new UnitStrategy({
    unitType: "Distance",
    defaultUnit: "KM",
    unitMaxLength: 2,
    allowNegatives: false,
    hasOffsets: false,
    items: {
      KM: { description: "Kilometers", sequence: 0, factor: 1000 },
      MI: { description: "Miles", sequence: 1, factor: 1609.344 },
      NM: { description: "Nautical Miles", sequence: 2, factor: 1852 },
    },
  }),

  Length: new UnitStrategy({
    unitType: "Length",
    defaultUnit: "M",
    unitMaxLength: 2,
    allowNegatives: false,
    hasOffsets: false,
    items: {
      MM: { description: "Millimeters", sequence: 0, factor: 0.001 },
      CM: { description: "Centimeters", sequence: 1, factor: 0.01 },
      M: { description: "Meters", sequence: 2, factor: 1 },
      KM: { description: "Kilometers", sequence: 3, factor: 1000 },
      IN: { description: "Inches", sequence: 4, factor: 0.0254 },
      FT: { description: "Feet", sequence: 5, factor: 0.3048 },
      YD: { description: "Yards", sequence: 6, factor: 0.9144 },
      MI: { description: "Miles", sequence: 7, factor: 1609.344 },
      NM: { description: "Nautical Miles", sequence: 8, factor: 1852 },
    },
  }),

  Volume: new UnitStrategy({
    unitType: "Volume",
    defaultUnit: "M3",
    unitMaxLength: 2,
    allowNegatives: false,
    hasOffsets: false,
    items: {
      CC: { description: "Cubic Centimeters", sequence: 0, factor: 0.000001 },
      L: { description: "Liter", sequence: 1, factor: 0.001 },
      M3: { description: "Cubic Meters", sequence: 2, factor: 1 },
      ML: { description: "Mega Liter", sequence: 3, factor: 1000 },
      CI: { description: "Cubic Inches", sequence: 4, factor: 0.000016387064 },
      CF: { description: "Cubic Feet", sequence: 5, factor: 0.0283168466 },
      CY: { description: "Cubic Yards", sequence: 6, factor: 0.764554858 },
      GA: { description: "US Gallons", sequence: 7, factor: 0.00378787878 },
      GI: { description: "Imperial Gallons", sequence: 8, factor: 0.00456621004 },
      D3: { description: "Cubic Decimeters", sequence: 9, factor: 0.001 },
      TE: { description: "Tea Chest", sequence: 10, factor: 0.127551 },
    },
  }),

  Weight: new UnitStrategy({
    unitType: "Weight",
    defaultUnit: "KG",
    unitMaxLength: 2,
    allowNegatives: false,
    hasOffsets: false,
    items: {
      MG: { description: "Milligrams", sequence: 0, factor: 0.000001 },
      G: { description: "Grams", sequence: 1, factor: 0.001 },
      KG: { description: "Kilograms", sequence: 2, factor: 1 },
      T: { description: "Tonnes", sequence: 3, factor: 1000 },
      OZ: { description: "Ounces", sequence: 4, factor: 0.0283495231 },
      LB: { description: "Pounds", sequence: 5, factor: 0.45359237 },
      TN: { description: "Short Tons (2000 lb)", sequence: 6, factor: 907.184995886 },
      TL: { description: "Long Tons (2240 lb)", sequence: 7, factor: 1016.04691 },
      OT: { description: "Ounces Troy", sequence: 8, factor: 0.03110347677 },
      LT: { description: "Pounds Troy", sequence: 9, factor: 0.3732417217 },
      MC: { description: "Metric Carat", sequence: 10, factor: 0.0002 },
      HG: { description: "Hectograms", sequence: 11, factor: 0.1 },
      DT: { description: "Decitons", sequence: 12, factor: 100 },
      KT: { description: "Kilo Tonnes", sequence: 13, factor: 1000000 },
    },
  }),

  Temperature: new UnitStrategy({
    unitType: "Temperature",
    defaultUnit: "C",
    unitMaxLength: 1,
    allowNegatives: true,
    hasOffsets: true,
    items: {
      C: { description: "Celsius", sequence: 0, factor: 1, offset: 0 },
      F: { description: "Fahrenheit", sequence: 1, factor: 1.8, offset: 32 },
    },
  }),

  Ventilation: new UnitStrategy({
    unitType: "Ventilation",
    defaultUnit: "MQH",
    unitMaxLength: 3,
    allowNegatives: false,
    hasOffsets: false,
    items: {
      MQH: { description: "Cubic Meters Per Hour", sequence: 0, factor: 1 },
      FQH: { description: "Cubic Feet Per Hour", sequence: 1, factor: 0.0283168 },
    },
  }),

  Default: new UnitStrategy({
    unitType: "Default",
    defaultUnit: "U",
    unitMaxLength: 1,
    allowNegatives: false,
    hasOffsets: false,
    items: {
      U: { description: "Unit", sequence: 0, factor: 1 },
    },
  }),
};
export default strategies;

/*! EndNoStringValidationRegion */
